import { Routes } from '@angular/router';
import { LoginComponent } from './login.component';

export const LOGIN_ROUTES: Routes = [
	{
		path:'login', component: LoginComponent
	}
];
